import React, { useState, useRef, useEffect, useMemo } from 'react'

import AlertModal from './AlertModal'
import style from './ModalPayCancel.module.scss'
import ModalPortal from '../../ModalPortal'
import { getBackgroundImageUrl } from '../../utils/imageEncodeUrl'

// 취소 사유
const reasons = [
  { reasonCode: 'REASON_11', value: '단순 변심' },
  { reasonCode: 'REASON_20', value: '결제수단 및 방법 변경' },
  { reasonCode: 'REASON_44', value: '다른 상품으로 재주문' },
  { reasonCode: 'REASON_29', value: 'APP 오류' },
  { reasonCode: 'REASON_5', value: '콘텐츠 강의 불만' },
  { reasonCode: 'REASON_38', value: '배송이 늦음' },
  { reasonCode: 'REASON_7', value: '타사 상품 구매' },
  { reasonCode: 'REASON_15', value: '상품 가격이 너무 높음' },
  { reasonCode: 'REASON_10', value: '기타' }
]

const ModalPayCancel = ({
  btnClose,
  handleCloseModal,
  putPayCancel,
  orderDetailData,
  paymentData,
  orderNo
}) => {
  const selectRef = useRef()
  const [flag, setFlag] = useState(false)
  const [modalopen, setModalopen] = useState(false)
  const [textareaValue, setTextareaValue] = useState('')
  const [cancelValue, setCancelValue] = useState('')
  const [reasonCode, setReasonCode] = useState('')

  const buttonClassName = useMemo(() => {
    const isDisabled = (flag && textareaValue.trim().length === 0) || (!flag && !cancelValue)

    return `btn ${isDisabled ? 'disabled' : 'active'}`
  }, [flag, textareaValue, cancelValue])

  const onChangeSelect = (e) => {
    const value = e.target.value
    e.target.classList.add('active')

    setCancelValue(value)

    // 선택한 value와 매칭되는 reasonCode 찾기
    const selectedReason = reasons.find((reason) => reason.value === value)
    setReasonCode(selectedReason ? selectedReason.reasonCode : '')

    if (value === '기타') {
      setFlag(true)
      setCancelValue('')
    } else {
      setFlag(false)
      setTextareaValue('')
    }
  }

  // 직접입력일 때 취소이유
  const handleTextareaValue = (e) => {
    setTextareaValue(e.target.value)
  }

  useEffect(() => {
    console.log('Updated reasonCode:', reasonCode)
  }, [reasonCode])

  // 취소 사유 설정
  const reason = cancelValue && cancelValue !== '기타' ? cancelValue : textareaValue?.trim()

  const handleOpenModal = (e) => {
    if (!reason || reason.length === 0) {
      alert('취소 사유를 선택해주세요.')
      return false
    }

    document.body.classList.add('modal-open')
    setModalopen(true)
  }

  const isMountedRef = useRef(true)

  useEffect(() => {
    return () => {
      isMountedRef.current = false
    }
  }, [])

  const handleConfirmClose = async (orderNo) => {
    if (orderNo) {
      const success = await putPayCancel(reason, reasonCode, orderNo)

      if (success && isMountedRef.current) {
        window.location.reload()
      }
    }

    if (isMountedRef.current) {
      document.body.classList.remove('modal-open')
      setModalopen(false)
    }
  }

  return (
    <>
      <div className="modal-wrap">
        <div className="dimmed" onClick={handleCloseModal}></div>
        <div className="modal-inner guide-size">
          {btnClose && (
            <button type="button" className="btn-modal-close" onClick={handleCloseModal}>
              <i className="blind">닫기</i>
            </button>
          )}
          <div className="modal-header">
            <strong>결제 취소 신청</strong>
          </div>
          <div className="modal-content type-fixed-button white">
            <div className={style.modalCancleWrap}>
              <div className={style.classInfoBoxWrap}>
                {orderDetailData?.orderDetailVOList ? (
                  orderDetailData.orderDetailVOList.map((item, idx) => (
                    <div className={style.classInfoBox} key={idx}>
                      <span
                        className={style.classImg}
                        style={{
                          backgroundImage: getBackgroundImageUrl(item.thumbnailPath)
                        }}
                      ></span>
                      <div className={style.classInfo}>
                        <p className={style.classTitle}>{item.orderName}</p>
                        <p className={style.classQuantity}>수량 {item.cnt}</p>
                        <p className={style.originalPrice}>
                          {item.originalPrice?.toLocaleString()}원
                        </p>
                        <p className={style.paymentPrice}>
                          <b>{item.paymentPrice?.toLocaleString()}</b>원
                        </p>
                      </div>
                    </div>
                  ))
                ) : (
                  <div>상품 정보를 불러오는 중입니다...</div>
                )}

                <div className="pay-cancle">
                  <strong>취소 사유</strong>
                  <select
                    name=""
                    className="modal-select-box"
                    ref={selectRef}
                    onChange={onChangeSelect}
                    defaultValue="default"
                  >
                    <option value="default" disabled>
                      취소 사유를 선택해주세요
                    </option>
                    {reasons.map(({ reasonCode, value }) => (
                      <option key={reasonCode} value={value}>
                        {value}
                      </option>
                    ))}
                  </select>

                  {flag && (
                    <div className={`${'textarea-wrap'} ${style.textareaBox}`}>
                      <textarea
                        maxLength="100"
                        placeholder="상세 사유를 입력해주세요. (선택)"
                        className="basic-textarea"
                        value={textareaValue}
                        onChange={handleTextareaValue}
                      ></textarea>
                      <span className={style.textareaCount}>
                        <b>{textareaValue.length}</b>/100
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <div className={style.payRefundWrap}>
                <div className={style.payRefund}>
                  <strong className={style.title}>환불 내역</strong>
                  <div className={style.payRefundAmount}>
                    <div className={style.item}>
                      <strong>결제 수단</strong>
                      <p
                        className={
                          'payment-method' +
                          (paymentData.paymentTypeCode === 'CARD' && ' credit-card ') +
                          (paymentData.paymentTypeCode === 'REMITTANCE' && ' no-bankbook ')
                        }
                      >
                        {paymentData?.paymentTypeName || '결제 수단 정보 없음'}
                      </p>
                    </div>
                    <div className={style.item}>
                      <strong>환불 상품 금액</strong>
                      <p className={style.paymentPrice}>
                        {paymentData?.totalPaymentPrice?.toLocaleString() || 0}원
                      </p>
                    </div>
                  </div>
                  <div className={`${style.item} ${style.totalRefundPrice}`}>
                    <strong className={style.title}>총 환불 금액</strong>
                    <p>{paymentData?.totalPaymentPrice?.toLocaleString() || 0}원</p>
                  </div>
                </div>

                <div className={style.payRefundInfo}>
                  <strong>결제취소안내</strong>
                  <ul>
                    <li>
                      결제하신 금액은 취소 즉시 환불처리됩니다. <br />
                      (환불 소요 기간은 결제 수단마다 다를 수 있음)
                    </li>
                    <li>
                      사용하신 쿠폰은 유효기간이 만료되지 않았다면 반환되며, 다시 사용하실 수
                      있습니다.
                    </li>
                    <li>
                      환불이 완료되 적용된 할인 혜택이 소멸될 수 있으며, 복구가 불가능하므로
                      신중하게 진행해 주세요.
                    </li>
                  </ul>
                </div>
                <button className={buttonClassName} onClick={handleOpenModal}>
                  <span>결제 취소</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalopen ? (
        <ModalPortal>
          <AlertModal
            btnConfirm
            titleMsg="결제 취소 완료"
            msg={'결제하신 금액은 취소 즉시\n환불 처리됩니다.'}
            customTag={<p className="info-txt">*환불 소요 기간은 결제 수단마다 다를 수 있음</p>}
            handleCloseModal={() => {
              handleConfirmClose(orderNo)
            }}
          />
        </ModalPortal>
      ) : null}
    </>
  )
}

export default ModalPayCancel
